// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-238ecb14]:export{primaryColor:#0460a9;secondaryColor:#f1f1f1;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
